import { BaseEntity } from 'yt-ng-framework';

export class KomitentObjekat extends BaseEntity {
    constructor(){
        super();
    }
    KomitentID: number = null;
    NazivObjekta: string = null;
    UlicaID: number = null;
    Adresa: string = null;
    Broj: string = null;
    PodBroj: string = null;
    MestoID: number = null;
    Gln: string = null;

    Deserialize(input: any){
        // super.Deserialize(input);
        this.ID = input.ID;
        this.KomitentID = input.KomitentID;
        this.NazivObjekta = input.NazivObjekta;
        this.UlicaID = input.UlicaID;
        this.Adresa = input.Adresa;
        this.Broj = input.Broj;
        this.PodBroj = input.PodBroj;
        this.MestoID = input.MestoID;
        this.Gln = input.Gln;
        return this;
    }

    Serialize(input: KomitentObjekat){
        return input;
    }
}